import React from 'react'

function ForcedBackToMap({unmount, updateUnmount}) {
    return (
        <>
            <p>
                You do not have enough evidence to visit this location! Larry does not take kindly to those who try to get around the rules...
            </p>
            <div>
                <button 
                    className='infoPopUp_btn' 
                    onClick={() => updateUnmount({name: 'waiting', state: true})}
                >
                    {unmount.waiting ? 'Loading Map' : 'Back To Map'}
                </button>
            </div>
        </>
    )
}

export default ForcedBackToMap